import * as React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../actions';

// Form Imports
import { Form, Field } from 'react-final-form';
import { FORM_ERROR } from 'final-form';

// Custom Components
import { TextFieldAdapter } from '../TextFieldAdapter';
import { PhoneNumberAdapter } from '../PhoneNumberAdapter';
import { TextFieldAdapterRT } from '../TextFieldAdapterRT';
import { FormIcon } from '../FormIcon';
import { ErrorMessage } from '../ErrorMessage';
import { ActionButton } from '../Buttons/ActionButton';
import { CancelButton } from '../Buttons/CancelButton';
import SelectFieldAdapter from 'components/Form/SelectFieldAdapter';
import AuthFormFooter from 'components/Form/AuthFormFooter';
import Checkbox from 'components/Form/Checkbox';
import TextButton from 'components/Button/TextButton';

// Utilities
import {
    required,
    isEmail,
    isPhoneNum,
    composeValidators,
    isNum,
    passwordsMatch,
    isValidName,
    isValidDOB,
} from '../validation';
import { constants } from '../../../constants/index';
import { getLocalTimestampFromDateString } from 'utils/timezoneUtils';
import { numbersOnly } from 'utils/stringUtils';
import { Link } from 'react-router-dom';

// Styled Components
import { FormGroup } from '../StyledComponents/FormGroup';
import { HiddenLabel } from '../StyledComponents/HiddenLabel';

// Vendor Libraries
import moment from 'moment-timezone';

const SignUpStep = props => {
    const {
        handleClose,
        errorData,
        resetErrors,
        handleChooseAuthDialog,
        errors,
        stepperControls,
        startSignUp,
    } = props;
    const { reverseStepper, advanceStepper } = stepperControls;

    const handleSignUp = async values => {
        if (
            values.password === values.passwordConfirmation &&
            values.hasAgreedToTerms
        ) {
            const dateOfBirthTimestamp = getLocalTimestampFromDateString(
                values.day && values.day.value,
                values.month && values.month.value,
                values.year && values.year.value,
            );
            const provinceOfResidence =
                values.provinceOfResidence && values.provinceOfResidence.value;
            const {
                email,
                phone,
                password,
                hasConsentedToMarketing = false,
                hasAgreedToTerms,
                firstName,
                lastName,
            } = values;
            const phoneNumbersOnly = numbersOnly(phone);

            let response = await startSignUp(
                email,
                phoneNumbersOnly,
                password,
                hasConsentedToMarketing,
                hasAgreedToTerms,
                firstName,
                lastName,
                provinceOfResidence,
                dateOfBirthTimestamp,
            )
                .then(user => {
                    console.log('ADVANCING STEPPER');
                    advanceStepper();
                })
                .catch(error => {
                    return { [FORM_ERROR]: 'Passwords must match.' };
                });
        }
    };

    const isWeak = () => {
        console.log(
            props.passwordData ? props.passwordData : null,
            props.passwordData ? props.passwordData.score : null,
        );
        if (props.passwordData && props.passwordData.score < 3) {
            return true;
        } else {
            return false;
        }
    };

    const checkPassword = value => {
        if (value) {
            props.checkPasswordStrength(value);
        }
    };

    const handleGetYears = () => {
        let currentYear = moment().format('YYYY');
        currentYear = parseInt(currentYear, 10);
        let yearList = [{ value: currentYear, label: `${currentYear}` }];
        while (yearList.length < 120) {
            yearList = [
                ...yearList,
                {
                    value: yearList[yearList.length - 1].value - 1,
                    label: `${yearList[yearList.length - 1].value - 1}`,
                },
            ];
        }
        return yearList;
    };

    const handleGetDay = () => {
        let days = [{ value: 1, label: '1' }];
        while (days.length < 31) {
            days = [
                ...days,
                {
                    value: days[days.length - 1].value + 1,
                    label: `${days[days.length - 1].value + 1}`,
                },
            ];
        }
        return days;
    };

    // console.log('props.serverError', props.errorData && props.errorData.message, props.errorData);
    return (
        <div style={styles.containerStyles} label="Sign Up">
            <h3 style={styles.titleStyles}>Create an Account</h3>
            <p style={styles.descriptionStyles}>
                Enter your information below to create a Cyno account and access
                all that Cyno has to offer.
            </p>
            <Form
                onSubmit={handleSignUp}
                validate={composeValidators(passwordsMatch, isValidDOB)}
                render={({
                    handleSubmit,
                    reset,
                    submitting,
                    pristine,
                    values,
                    invalid,
                }) => (
                    <form
                        id="authForm"
                        onSubmit={handleSubmit}
                        style={{ marginTop: 30, marginBottom: -30 }}
                    >
                        <FormGroup>
                            <HiddenLabel> Name </HiddenLabel>
                            <Field
                                name="firstName"
                                component={TextFieldAdapter}
                                type="text"
                                placeholder="First Name"
                                style={{ maxWidth: 195 }}
                                validate={composeValidators(
                                    required,
                                    isValidName,
                                )}
                            />
                            <Field
                                name="lastName"
                                component={TextFieldAdapter}
                                type="text"
                                placeholder="Last Name"
                                style={{ maxWidth: 195 }}
                                validate={composeValidators(
                                    required,
                                    isValidName,
                                )}
                            />
                        </FormGroup>

                        <FormGroup>
                            <HiddenLabel>Email</HiddenLabel>
                            <Field
                                name="email"
                                component={TextFieldAdapter}
                                type="text"
                                placeholder="Email"
                                validate={isEmail}
                                icon="envelope"
                            />
                        </FormGroup>

                        <FormGroup>
                            <HiddenLabel>Phone Number</HiddenLabel>
                            <Field
                                name="phone"
                                component={PhoneNumberAdapter}
                                type="text"
                                placeholder="Phone Number"
                                validate={isPhoneNum}
                                icon="phone"
                            />
                        </FormGroup>

                        <FormGroup>
                            <HiddenLabel>Password</HiddenLabel>
                            <Field
                                name="password"
                                component={TextFieldAdapter}
                                type="password"
                                placeholder="Password"
                                icon="lock"
                                validate={value => {
                                    checkPassword(value);
                                    return value ? undefined : 'Required';
                                }}
                                // style={{paddingBottom: 30}}
                            />
                        </FormGroup>
                        {(values.password || values.password === '') &&
                            !values.passwordConfirmation && (
                                <div style={{ marginTop: 30 }}>
                                    {(values.password ||
                                        values.password === '') && (
                                        <div
                                            className={`strengthIndicator ${
                                                props.passwordData
                                                    ? props.passwordData.color
                                                    : ''
                                            }`}
                                        />
                                    )}
                                    {values.password && (
                                        <span>
                                            {props.passwordData
                                                ? props.passwordData.message
                                                : ''}
                                        </span>
                                    )}
                                </div>
                            )}

                        <FormGroup>
                            <HiddenLabel>Confirm Password</HiddenLabel>
                            <Field
                                name="passwordConfirmation"
                                component={TextFieldAdapter}
                                type="password"
                                placeholder="Confirm Password"
                                icon="lock"
                                validate={required}
                            />
                        </FormGroup>
                        <p
                            style={{
                                ...styles.descriptionStyles,
                                marginTop: 0,
                            }}
                        >
                            <strong>Province of Residence</strong>
                        </p>
                        <div style={styles.formFieldStyles}>
                            <HiddenLabel>Province of Residence</HiddenLabel>
                            <Field
                                name="provinceOfResidence"
                                component={SelectFieldAdapter}
                                options={constants.option.provinces}
                                style={{ maxWidth: 150 }}
                                validate={value => {
                                    return value ? undefined : 'Required';
                                }}
                            />
                            <FormIcon
                                name="map-marker-alt"
                                style={{ color: '#C3C3C3' }}
                            />
                        </div>
                        <p
                            style={{
                                ...styles.descriptionStyles,
                                marginTop: 20,
                            }}
                        >
                            <strong>Birthday</strong>
                        </p>
                        {/*
                            ******** Show this with tooltip component *********
                            <FormIcon name="question-circle" size={10} style={{color: '#C3C3C3'}}></FormIcon>
                            <p style={ styles.descriptionStyles }>
                            To sign up, you must be 18 or older. Other people won’t see your birthday.
                        </p>*/}
                        <FormGroup>
                            <HiddenLabel>Date of Birth</HiddenLabel>
                            <Field
                                name="month"
                                component={SelectFieldAdapter}
                                options={constants.option.months}
                                type="number"
                                placeholder="Month"
                                validate={required}
                                style={{ minWidth: 100, paddingBottom: 10 }}
                            />
                            <Field
                                name="day"
                                component={SelectFieldAdapter}
                                options={handleGetDay()}
                                type="number"
                                placeholder="Day"
                                validate={required}
                                style={{ minWidth: 100, paddingBottom: 10 }}
                                // readOnly={true}
                            />
                            <Field
                                name="year"
                                component={SelectFieldAdapter}
                                options={handleGetYears()}
                                type="number"
                                placeholder="Year"
                                validate={required}
                                style={{ minWidth: 100, paddingBottom: 10 }}
                            />
                        </FormGroup>

                        <Field
                            name="hasConsentedToMarketing"
                            render={({ input }) => (
                                <Checkbox
                                    input={input}
                                    labelText="I agree to receive service suggestions, company updates and other promotions from Cyno. You can withdraw your consent at any time in account settings or via the link in the message."
                                    style={{ paddingTop: 25 }}
                                />
                            )}
                        />

                        <Field
                            name="hasAgreedToTerms"
                            validate={required}
                            render={({ input }) => (
                                <Checkbox
                                    input={input}
                                    // labelText='I have read and agree to Cyno’s Terms of Use and Privacy Policy.'
                                >
                                    <span>
                                        I have read and agree to Cyno’s&nbsp;
                                        <Link
                                            to="terms_and_conditions"
                                            target="_blank"
                                            style={{
                                                color: 'lightblue',
                                                textDecoration: 'underline',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            Terms&nbsp;Of&nbsp;Use
                                        </Link>
                                        <span> </span>and<span> </span>
                                        <Link
                                            to="privacy_policy"
                                            target="_blank"
                                            style={{
                                                color: 'lightblue',
                                                textDecoration: 'underline',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            Privacy&nbsp;Policy
                                        </Link>
                                        .
                                    </span>
                                </Checkbox>
                            )}
                        />

                        {props.errorData && (
                            <ErrorMessage errors={props.errorData} />
                        )}

                        <div
                            style={{
                                ...styles.centerContainer,
                                paddingTop: 30,
                            }}
                        >
                            <p style={styles.descriptionStyles}>
                                We will send you notification and policy updates
                                via email.
                            </p>
                            {/*<button onClick={(event)=>{ event.preventDefault(); handleSubmit(event); resetErrors(reset);}}>Create Account</button>*/}
                            {/* make new button component to replace Mui */}
                            <ActionButton
                                options={{
                                    label: 'Create Account',
                                    form: 'authForm',
                                    isNextButton: true,
                                    action: event => {
                                        event.preventDefault();
                                        handleSubmit(event);
                                        resetErrors(reset);
                                        // props.clearAuthErrors();
                                        // Dont advance here wait until a successful sign up
                                        // advanceStepper();
                                    },
                                    disabled: isWeak() || invalid,
                                }}
                            />
                        </div>

                        <AuthFormFooter>
                            <h2
                                style={{
                                    display: 'flex',
                                    color: 'rgba(0,0,0,0.6)',
                                    fontSize: 14,
                                }}
                            >
                                Already have an account?
                            </h2>
                            <TextButton
                                onClick={event => {
                                    event.preventDefault();
                                    resetErrors(reset);
                                    props.clearAuthErrors();
                                    handleChooseAuthDialog('login');
                                }}
                            >
                                <h2
                                    style={{
                                        display: 'flex',
                                        color: '#379DA8',
                                        fontSize: 14,
                                    }}
                                >
                                    Log in
                                </h2>
                            </TextButton>
                        </AuthFormFooter>
                    </form>
                )}
            />
        </div>
    );
};

const mapStateToProps = ({ auth, dialog }) => {
    // console.log('AUTH ERROR @ SIGN UP', auth.serverError);
    return {
        userId: auth.authData ? auth.authData.id : null,
        userEmail: auth.authData ? auth.authData.email : null,
        errorData: auth.serverError,

        emailIsVerified: auth.verificationStatus,
        currentDialog: dialog.current,
        passwordData: auth.passwordData,
    };
};
export const SignUpStepDisconnected = SignUpStep;
export default connect(
    mapStateToProps,
    actions,
)(SignUpStep);

/*
  
  handleClose
  errorData
  resetErrors
  
  */

const styles = {
    containerStyles: {
        fontSize: constants.text.baseFontStyles.fontSize,
    },
    descriptionStyles: {
        display: 'flex',
        color: 'rgba(0,0,0,0.4)',
        fontSize: 13,
        marginTop: -10,
    },
    titleStyles: {
        marginTop: 0,
    },
    formFieldStyles: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 15,
    },
    centerContainer: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        flexFlow: 'column nowrap',
        marginBottom: 15,
        marginTop: 20,
    },
};



// WEBPACK FOOTER //
// ./src/js/components/Form/Steps/SignUpStep.jsx